<!--
 * @Description: 
 * @Author: dezhi
 * @Date: 2021-05-21 11:07:26
 * @LastEditTime: 2021-05-27 10:54:22
 * @LastEditors: dezhi
-->
<template>
  <section
    class="page-authorize d-flex flex-column align-items-center justify-content-center bg-white"
  >
    <img src="@/assets/images/logo.svg" width="150" />
    <div class="loading mt-5">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
    <div class="mt-2">微信授权中</div>
  </section>
</template>

<script>
/* eslint-disable */

import { mapState, mapMutations, mapGetters } from "vuex";
import baseConf from "@/assets/js/conf";

export default {
  //   layout: "normal",
  components: {},
  data() {
    return {
      redirect: "",
    };
  },
  mounted() {
    this.authorizeInit();
  },
  methods: {
    authorizeInit() {
      this.getOpenid();
    },
    /**
     * @description: 微信登录时掉用
     * @param {type}
     * @return {type}
     */
    getOpenid() {
      let query = this.$route.query;
      this.$store.dispatch("wx/getOpenIdAction", query.code).then((res) => {
        if (res.data.status == 2000) {
          let userInfo = res.data.data.userInfo;
          // if (userInfo.wxFlag == 0) {
          //   localStorage.setItem("openid", userInfo.openid);
          //   localStorage.setItem("refreshToken", userInfo.refreshToken);
          //   location.href = `http://${baseConf.baseUri}/bind?redirect=${this.redirect}`;
          // } else {
          //   location.href = `http://${baseConf.baseUri}${this.redirect}`;
          // }
        }
      });
    },
  },
};
</script>

<style lang="less">
section {
  height: 100vh;
  .loading span {
    display: inline-block;
    vertical-align: middle;
    width: 0.6em;
    height: 0.6em;
    margin: 0.19em;
    background: #ccc;
    border-radius: 0.6em;
    animation: loading 1.6s infinite ease-in-out;
  }

  /*
 * Dots Colors
 * Smarter targeting vs nth-of-type?
 */
  .loading span:nth-of-type(2) {
    background: #ccc;
    animation-delay: 0.2s;
  }
  .loading span:nth-of-type(3) {
    background: #ccc;
    animation-delay: 0.4s;
  }
  .loading span:nth-of-type(4) {
    background: #ccc;
    animation-delay: 0.6s;
  }
  .loading span:nth-of-type(5) {
    background: #ccc;
    animation-delay: 0.8s;
  }
  .loading span:nth-of-type(6) {
    background: #ccc;
    animation-delay: 1s;
  }
  .loading span:nth-of-type(7) {
    background: #ccc;
    animation-delay: 1.2s;
  }

  /*
 * Animation keyframes
 * Use transition opacity instead of keyframes?
 */
  @keyframes loading {
    0%,
    100%,
    20% {
      background: #ccc;
      transform: scale(1);
    }
    60% {
      background: #007bff;
      transform: scale(1.3);
    }
  }
}
</style>
